var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"unicom-notice-bar"}},[_c('van-notice-bar',{attrs:{"color":"#275BF5","background":"#E8EdFD","speed":30,"scrollable":_vm.scrollable,"text":_vm.textContent}},[_c('template',{slot:"left-icon"},[_c('img',{staticClass:"left-icon",attrs:{"src":"/pub/pre/h5/icon/icon_horn_blue.png"}})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }